import { OFFER_FIRST_TYPE } from "@constants";
import PropTypes from "prop-types";
import { useSnapshot } from "valtio";

import React from "react";

import { getProductTitle } from "@components/OrderTaking/Helpers";

import { kioskStore } from "@pages/Kiosk/store";

export function ProductDetails({
    product,
    isPriceShown,
    isProductDescriptionActive,
}) {
    const { isPrm, devise } = useSnapshot(kioskStore);
    const {
        price,
        isStepItem,
        hidePrice,
        hideZeroPrice,
        isFormulaItem,
        formulaPrincipalItemPrice,
    } = product;

    const productDescriptionContent = getProductTitle(
        product.description,
        product
    );

    const shouldHidePrice = isStepItem
        ? hidePrice && price?.content === 0
        : (hideZeroPrice && price?.content === 0) ||
          (product.offer?.isEnabled &&
              product.offer?.type === OFFER_FIRST_TYPE);

    const displayedPrice = isFormulaItem
        ? price?.content - formulaPrincipalItemPrice
        : price?.content;

    const formatPrice = (value) =>
        `${value.toFixed(devise.decimalPrice)} ${devise.deviseSymbole}`;

    const PriceValue = shouldHidePrice
        ? null
        : isFormulaItem
        ? `${displayedPrice >= 0 ? "+" : ""}${formatPrice(displayedPrice)}`
        : formatPrice(displayedPrice);

    return (
        <div style={{ height: "100%" }}>
            {isPriceShown ? (
                <div
                    className={`d-flex justify-content-center align-items-start px-1 ${
                        isPrm ? "prm-price" : "price"
                    }`}
                    style={{
                        fontSize: "var(--font-size-base)",
                        color: "var(--font-color-base)",
                        fontWeight: 700,
                        textAlign: "center",
                        alignItems: "center !important",
                    }}
                >
                    {PriceValue}
                </div>
            ) : null}
            <span
                className={`px-2 two-lines-preview-text ${
                    isPrm ? "prm-description pt-1 " : "description__clz pb-1"
                }`}
                style={{
                    fontSize: "var(--font-size-base)",
                    fontWeight: 500,
                    lineHeight: "1.2em",
                    textAlign: "center",
                }}
            >
                {isProductDescriptionActive ? productDescriptionContent : null}
            </span>
        </div>
    );
}

ProductDetails.propTypes = {
    product: PropTypes.object.isRequired,
    isPriceShown: PropTypes.bool,
    isProductDescriptionActive: PropTypes.bool,
};
